const StyleSheetColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary',
  Quaternary: 'quaternary',
  Tint: 'tint',
  White: 'white',
  Success: 'success',
  Error: 'error',
  Branded: 'branded',
} as const;

type StyleSheetColorType = typeof StyleSheetColor[keyof typeof StyleSheetColor];

export { StyleSheetColor, StyleSheetColorType };
